
import CircleSvg from '~/components/shared/Circle/CircleSvg.vue'
import { triggerAnimation } from '~/utils/trigger'

export default {
  components: {
    CircleSvg,
  },
  props: {
    item: {
      default: () => ({}),
    },
  },
  data() {
    return {
      active: 0,
    }
  },
  computed: {
    activeFeature() {
      return this.item.items[this.active]
    },
  },
  mounted() {
   setTimeout(() => {
    triggerAnimation(
      document.querySelectorAll('.feature-one-image'),
      'fadeInLeftBig'
    )
   }, 250);
  },
}
